import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faPencilAlt,
    faTrash
} from "@fortawesome/free-solid-svg-icons";

import ActivityFooter from "./ActivityFooter";

export default function ActivityView({
    activity,
    onEdit,
    onDelete
}) {

    if (!activity) return null;

    return (
        <div className="workitem-activity-view">

            {/* ACTIONS */}
            <div className="workitem-activity-actions">

                {
                    activity.Editable && (
                        <FontAwesomeIcon
                            icon={faPencilAlt}
                            className="text-primary cursor-pointer"
                            onClick={onEdit}
                        />
                    )
                }

                {
                    activity.Editable && (
                        <FontAwesomeIcon
                            icon={faTrash}
                            className="text-danger cursor-pointer ms-2"
                            onClick={onDelete}
                        />
                    )
                }

            </div>

            {/* MESSAGE */}
            <div className="comment-message">
                {activity.Message}
            </div>

            {/* FOOTER */}
            <ActivityFooter activity={activity} />

        </div>
    );
}